import React from 'react';

export const OpenInNewWindowIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15 .702v4.783a.705.705 0 01-.7.702.705.705 0 01-.699-.702V2.291L6.81 9.131a.701.701 0 01-.982 0 .7.7 0 01-.2-.485.7.7 0 01.2-.485l6.726-6.756h-3.03a.705.705 0 01-.7-.703c0-.384.317-.702.7-.702H14.3c.383 0 .699.318.699.702z"
            fill="currentColor"
        />
        <path
            d="M8.024 3.11a.705.705 0 01-.699.702H1.848a.477.477 0 00-.466.469v8.863c0 .25.216.468.466.468h8.84c.25 0 .466-.217.466-.468V7.625c0-.384.317-.702.7-.702.382 0 .699.318.699.702v5.519A1.873 1.873 0 0110.688 15h-8.84A1.859 1.859 0 010 13.144v-8.88c0-1.02.832-1.856 1.848-1.856h5.477c.383 0 .7.317.7.702z"
            fill="currentColor"
        />
    </svg>
);
